import React from 'react';
import { THeaderContext } from '../../../types/THeaderConfig';

const HeaderContext = React.createContext<null | THeaderContext>(null);

export default HeaderContext;
